/**
 * FirmaProfilIncelemePage.jsx — Firma Profili İncele (inceleme/admin tarafı)
 * Route: /Management/Firmalar/Profil, /Management/Firmalar/Profil/:firmaId
 *
 * `FirmaKartPage.jsx`in (Firma-tarafı, salt okunur self-servis "Firma Kartı") ADMİN
 * karşılığı — bir denetmenin/adminin herhangi bir firmanın profilini ve TÜM belgelerini
 * (gerçek `id`, ham approval_status, red gerekçesi, gerçek dosya) görüp
 * onaylayabileceği/reddedebileceği sayfa. 2026-08-10, `docs/guides/FE-FirmaController-guide.md`
 * doğrudan canlı yerel backend'e karşı kuruldu — mock katmanı hiç olmadı: inceleme/onay
 * akışının kendisi zaten sadece gerçek backend'e karşı anlamlı, bkz. `firmaService.js`teki
 * `getFirmaProfilePage`/`getFirmaDocumentsAdmin`/`reviewFirmaDocument`.
 *
 * Varsayılan hedef firma 49858 / fuar 298 (rehberdeki tam dolu mock fixture) — sayfa
 * üstündeki mini formdan başka bir firmaId/fuarId'ye geçilebilir.
 *
 * Backlog #33 (2026-09-16): "Firma Bilgileri" sekmesine Düzenle (PUT /firma/{firmaId}, #32) ve
 * kalıcı Sil (DELETE /firma/{firmaId}/hard-delete) eklendi — bu modülün TEK gerçek CRUD boşluğu,
 * çünkü eski mock sayfa (FirmaListPage.jsx/FirmaFormModal.jsx) 2026-09-12'deki Kartlar/Detay
 * dönüşümünden beri hiçbir rotadan erişilemiyordu ve silindi. Oluşturma zaten CreateFirmaModal.jsx
 * üzerinden canlı.
 *
 * 2026-08-10 revizyonu: belge onaylama, kişi kaydı yaratmayla köprülendi — İş Yeri
 * Hekimi/İş Güvenliği Uzmanı Ataması (fileTypeId 88/89) onaylandığında, belgede adı
 * geçen kişiyi doğrudan firmanın yetkilileri arasına eklemeyi teklif eden bir modal
 * açılıyor. Aynı buton her iki belge satırında ve grup kartlarının başlığında da duruyor.
 * Bu AYNI kayıtları firma-tarafı Firma Kartı sayfası (FirmaKartPage.jsx, "Firma
 * Yetkilileri" sekmesi) salt okunur gösteriyor — burada oluşturulan kişi ekstra bir
 * kablolamaya gerek kalmadan firma tarafında da görünür.
 *
 * Backlog #63 (2026-09-19, backend #62): sekme "Sağlık ve Güvenlik Yetkilileri" değil
 * "Firma Yetkilileri" — İSG yetkilileri ve Firma Temsilcisi birlikte. Roller artık sabit
 * DEĞİL, `firma_yetkili_rol` kataloğundan geliyor (`profile-page.yetkiliRolleri[]`):
 * gruplar, başlıklar, sıra, ekleme formunun seçenekleri ve "bu belgeden kişi oluştur"
 * köprüsü hep oradan türüyor, yani dördüncü bir rol tek bir INSERT'le eklenince bu sayfa
 * değişmeden çalışır (bkz. Components/Firma/yetkiliGruplari.js). Satırda rol artık
 * ikonun yanı sıra ETİKET olarak da yazılı. PUT/DELETE bu geçişte bağlandı — silme
 * KALICI, atama belgesi ise firma belgelerinde kalır.
 *
 * Backlog #60 (2026-09-19, backend #61): "Firma Bilgileri" sekmesi artık firma-tarafı
 * Firma Kartı sayfasıyla aynı blokları gösteriyor — firma logosu, kategoriler + katalog
 * açıklaması, fotoğraf galerisi ve harita konumu. Üçü de düzenlenebilir: yazma uçlarının
 * yetki kontrolü firma kullanıcısını kendi firmasıyla sınırlar ama personeli (staff)
 * sınırlamaz. Ortak bloklar Components/Firma/FirmaBilgiKartlari.jsx'te; hiçbiri ek bir
 * istek atmıyor — profile-page cevabı `fotograflar[]`, latitude/longitude, kategoriDetay
 * ve firmaLogoUrl'ı zaten taşıyor. Harita leaflet + react-leaflet.
 *
 * Backlog #156 (backend #123): Belgeler tablosu iki firma belge grubuna bölündü — Firma
 * Belgeleri ve Firma İSG Belgeleri, her biri grup durum rozetiyle; grubun yüklenmemiş
 * belgeleri de "Yüklenmedi" satırı olarak görünür, gruba girmeyen her şey "Diğer
 * Belgeler"de. Gruplar profile-page'in belgeGruplari[]'ından (fuarId ile), satırlar hâlâ
 * GET /documents'tan; eşleme Components/Firma/belgeGruplari.js'te. Onay/red türden
 * bağımsız, Faaliyet Belgesi (94) için ek bir şey gerekmedi.
 *
 * Backlog #106 (2026-10-01, backend #105): Firma Temsilcisi rolünün etiketi "Firma
 * Yetkilisi" oldu (kod/grupKod sabit; etiket veri). O grup sekmenin en ÜSTÜNDE ve profil
 * kartıyla basılıyor (fotoğraf, departman, doğum tarihi, LinkedIn, biyografi, bağlı portal
 * hesabı — Components/Firma/YetkiliProfil.jsx, firma portalıyla ortak). Ekleme/düzenleme
 * modalı o rol için aynı alanları + fotoğraf yüklemeyi de alıyor. İSG rolleri eski kartta.
 *
 * Backlog #196: 79'un adı backend'de 'Taahhütname' kalıyor, bu sayfada 'Firma İSG Taahhütnamesi'
 * yazıyor — satırlar, onay/red bildirimleri ve red modalı belgeGorunenAd'dan geçiyor.
 *
 * Backlog #201: personel firma adına belge yükleyebiliyor — yalnızca gruplardaki "Yüklenmedi" ve
 * "Reddedildi" satırlarında. Firma portalıyla aynı uploadFirmaGrupBelgesi (fuarId yalnızca fuaraOzel
 * belgede gider); belge firma yüklemesi gibi Beklemede'ye düşer, aynı satırdaki Onayla ile
 * onaylanır. Yükleyen kullanıcı backend'de oturumdan yazılıyor (firma_document.uploaded_by);
 * #257'den beri satırın Güncelleme hücresinde "Yükleyen: ad (Personel/Firma)" ve, incelenmiş satırda,
 * "İnceleyen: ad" yazıyor. Reddedilmiş satıra yüklemek aynı satırı ezer: red gerekçesi silinir.
 *
 * Backlog #212 (2026-10-13): Belgeler tablosu GET /documents yerine GET /firma/{id}/evraklar'dan
 * (firmaService.getFirmaEvraklari): gruplar satırlarıyla geliyor (eşlemeyi backend yapıyor) ve
 * "Diğer Belgeler" digerBelgeler'den. profile-page diğer sekmeler için duruyor.
 *
 * Backlog #142: Belgeler sekmesinin altında firmanın PAYLAŞIMLI personel belgeleri (SGK Hizmet Dökümü /
 * İSG Eğitim Katılım Listesi) — PaylasimliBelgelerPanel `staff` kipinde: çalışan başına onay/red.
 *
 * Backlog #251 (backend #200): İSG grubunda 99 İşveren İSG Görevlendirmesi satırı (88+89 yerine geçer;
 * "gruba sayılmaz" DEĞİL — bkz. belgeNotu). 99 onaylanınca "belgede adı geçen kişiyi kaydet" köprüsü
 * katalogdaki 4. rolden kendiliğinden gelir.
 *
 * Backlog #483 (backend #482, 2026-10-19): Belgeler sekmesinin en üstündeki "İşveren İSG görevlendirmesi
 * kabul edilir" anahtarı (Components/Firma/IsgIsverenIzniKarti.jsx) KALDIRILDI (dosya duruyor, yorumda).
 * 99 her Yerli firmaya sunulur ve denetmen Onayla'ya bastığında sayılır; 88 / 89 ne olursa olsun. Kararı
 * artık bu tıklama verir: 99'un (ve yerine geçen her belgenin) Onayla düğmesinin ipucu "50'den az
 * çalışanı olan firmalar için" hatırlatır (#509: ileride kaldırılabilir).
 *
 * Backlog #197 (2026-10-10): Düzenle modalında Vergi Numarası (GET /firma/{id}/tax-number'dan okunur,
 * PUT /firma/{id}'ye taxNumber olarak gider; kural Components/Firma/vergiNo.js).
 *
 * Backlog #195 (2026-10-10): "Tehlikeli Bölge" kartı kaldırıldı (yorumda duruyor). Firmayı Sil artık Firma
 * Bilgileri başlığında ve yalnızca FIRMA_HARD_DELETE yetkisi olana görünüyor (rbacService.getMyPermissions);
 * backend de aynı yetkiyi istiyor. Varsayılan olarak yalnızca SuperAdmin'de; kök Yetki Yönetimi'nden verir.
 */
import React, { useEffect, useState, useContext } from "react";
import { useParams, useNavigate, useSearchParams } from "react-router-dom";
import {
  Card, CardBody, CardHeader, Row, Col, Button, Input, Label, Table,
  Badge, Spinner, Alert, Modal, ModalHeader, ModalBody, ModalFooter, Nav, NavItem, NavLink,
} from "reactstrap";
import { Building2, FileText, CheckCircle2, XCircle, ExternalLink, UserPlus, Pencil, Trash2, Upload } from "lucide-react";
import { PageFrame, PageBody } from "../../../../Components/Common/EmbeddablePage";
import MainContext from "../../../../Components/Contexts/MainContext";
import { firmaService, getFirmaDocumentFileUrl, REVIEWER_USER_ID } from "../../../../services/firmaService";
import { buildYetkiliGruplari, eklenebilirRoller, belgeTipiRolHaritasi, yetkiliIkonu, profilGrubuMu } from "../../../../Components/Firma/yetkiliGruplari";
import {
  YetkiliProfilKarti, YetkiliProfilAlanlari, EMPTY_YETKILI_FORM, EMPTY_YETKILI_FOTO,
  yetkiliFormundan, yetkiliPayload, yetkiliKaydet,
} from "../../../../Components/Firma/YetkiliProfil";
import { getFirmaKullanicilar, uploadFirmaGrupBelgesi } from "../../../../services/firmaProfileService";
import FirmaKullanicilarBolumu from "./FirmaKullanicilarBolumu";
import {
  siraliBelgeGruplari, grupDurumInfo, grupKartNotu, belgeGorunenAd, belgeNotu, belgeUygulanamazMi, uygulanamazDurumu, ISG_TAAHHUTNAMESI_FILE_TYPE_ID,
} from "../../../../Components/Firma/belgeGruplari";
import IsgTaahhutnameIndir from "../../../../Components/Firma/IsgTaahhutnameIndir";
// #736: staff delete any uploaded company document (page.firma; an approved one asks for a second confirmation, backend #735).
import FirmaBelgeSilModal from "../../../../Components/Firma/FirmaBelgeSilModal";
import PaylasimliBelgelerPanel from "../../../../Components/Firma/PaylasimliBelgelerPanel";
// WAS (until #483): import IsgIsverenIzniKarti from "../../../../Components/Firma/IsgIsverenIzniKarti";
// #313 (2026-10-11): yabancı firma anahtarı (#312) ve organizatör firmanın portal ayarları (#316) — yalnızca personel.
import YabanciFirmaKarti from "../../../../Components/Firma/YabanciFirmaKarti";
import OrganizatorYetkileriKarti from "../../../../Components/Firma/OrganizatorYetkileriKarti";
import {
  FirmaLogo, KatalogBilgileriCard, FirmaFotograflarCard, FirmaKonumCard,
} from "../../../../Components/Firma/FirmaBilgiKartlari";
import { getTaxNumber } from "../../../../services/cardAccessService";
// WAS (until #554): import { vergiNoHatasi, vergiNoTemizle, VERGI_NO_MAX } from "../../../../Components/Firma/vergiNo"; — the inline edit modal below
// is gone; the shared Firma Bilgilerini Düzenle modal (staff mode) carries the name / tax number rules.
import FirmaBilgileriDuzenleModal from "../../../../Components/Firma/FirmaBilgileriDuzenleModal";
import KontrolluSilDugmesi from "../../../../Components/Common/KontrolluSilDugmesi";
import { useTranslation } from "react-i18next";
import { sablonHaritasi } from "../../../../services/documentTemplateService";
import BelgeSablonuBaglantilari from "../../../../Components/Common/BelgeSablonuBaglantilari";
import i18n, { currentLocaleTag } from "../../../../i18n";
import TelefonGirdisi from "../../../../Components/Common/TelefonGirdisi";

// Fixture belgelerinin varsayılan hedefi (bkz. FE-FirmaController-guide.md) —
// firmaProfileService.js'teki TEST_DECORATOR_FIRMA_ID/TEST_FUAR_ID ile aynı değerler,
// dosya-yerel kopya (bu sayfa o servisi import etmiyor, admin tarafı ayrı).
const DEFAULT_FIRMA_ID = 49858;
const DEFAULT_FUAR_ID = 298;

// Ham approval_status (0 yüklenmedi / 1 beklemede / 2 onaylandı / 3 reddedildi) —
// GET /documents sadece var olan satırları döner, pratikte 1/2/3 görülür.
const RAW_STATUS = {
  0: { get label() { return i18n.t("moduller:firmaProfilInceleme.yuklenmedi"); }, color: "secondary" },
  1: { get label() { return i18n.t("moduller:firmaProfilInceleme.beklemede"); }, color: "warning" },
  2: { get label() { return i18n.t("moduller:firmaProfilInceleme.onaylandi"); }, color: "success" },
  3: { get label() { return i18n.t("moduller:firmaProfilInceleme.reddedildi"); }, color: "danger" },
};


// Atama belgesi onaylandığında hangi Sağlık ve Güvenlik Yetkilisi rolünün oluşturulacağını
// gösterir — fileTypeId 88/89, bkz. FE-FirmaController-guide.md Constants. Belgede adı geçen
// kişiyi kaydetmek, atamanın kendisini onaylamaktan ayrı bir adım (backend'de tek bir kişi/
// atama FK'ı yok, bkz. rehberin "atamaBelgesiStatus firmayı tanımlar, kişiyi değil" notu) —
// bu yüzden burada elle tetikleniyor, otomatik değil.
// (Rol etiketleri/ikonları ve belge→rol köprüsü artık #62 kataloğundan türüyor —
// bkz. Components/Firma/yetkiliGruplari.js. Sabit rol listesi BİLEREK kaldırıldı.)
// #697: `hata` = a refused save, shown inside the window (it stays open until a save succeeds).
const EMPTY_YETKILI_MODAL = {
  isOpen: false, mode: "create", id: null, rol: "", rolLocked: false, contextLabel: "", hata: null,
  form: EMPTY_YETKILI_FORM, foto: EMPTY_YETKILI_FOTO,
};
// Backlog #11 — sayfa tek bir uzun akışa sığdırılmış üç bölümü (bilgiler /
// sağlık-güvenlik yetkilileri / belgeler) içeriyordu; FirmaKartPage.jsx /
// StandOverviewDetailPage.jsx'teki aynı Nav-pills + activeTab deseniyle
// sekmelere bölündü. ?tab=<key> ile açılış sekmesi dışarıdan seçilebilir
// (aynı desen, bkz. FirmaKartPage.jsx).
const TABS = [
  { key: "bilgiler", get label() { return i18n.t("moduller:firmaProfilInceleme.firmaBilgileri"); } },
  { key: "yetkililer", get label() { return i18n.t("moduller:firmaProfilInceleme.firmaYetkilileri"); } },
  // 2026-10-19: Firma Kartı'ndaki (firma tarafı) "Kullanıcılar" bölümünün denetmen karşılığı + "Kullanıcı ekle".
  { key: "kullanicilar", get label() { return i18n.t("moduller:firmaProfilInceleme.kullanicilar"); } },
  { key: "belgeler", get label() { return i18n.t("moduller:firmaProfilInceleme.belgeler"); } },
  // #595: Firma Bilgileri'nden taşınan organizatör yetkileri + ödeme bağlantısı (ücretsiz kW aşımı).
  { key: "diger", get label() { return i18n.t("moduller:firmaProfilInceleme.diger"); } },
];

function formatDate(iso) {
  if (!iso) return "—";
  try { return new Date(iso).toLocaleString(currentLocaleTag()); } catch { return iso; }
}

// #196 — GET /documents satırının ekranda yazılacak türü adı (79 → 'Firma İSG Taahhütnamesi').
const docAdi = (doc) => belgeGorunenAd(doc.fileTypeId, doc.fileTypeName);

/**
 * @param {boolean} embedded  true → sayfa kabuğu (page-content/Container/BreadCrumb) ve
 *                            firmaId/fuarId mini formu basılmaz; hedef firma prop'tan gelir.
 *                            FirmaDetayPage.jsx'in "Profil & Belgeler" sekmesi bu modda kullanır.
 */
export default function FirmaProfilIncelemePage({ embedded = false, firmaId: firmaIdProp, fuarId: fuarIdProp }) {
  const { t: tx } = useTranslation("moduller");
  const { firmaId: firmaIdParam } = useParams();
  const [searchParams, setSearchParams] = useSearchParams();
  const navigate = useNavigate();
  const { selectedFuarId } = useContext(MainContext);

  const firmaId = firmaIdProp ?? (firmaIdParam ? Number(firmaIdParam) : DEFAULT_FIRMA_ID);
  const fuarId = fuarIdProp ?? (Number(searchParams.get("fuarId")) || Number(selectedFuarId) || DEFAULT_FUAR_ID);

  const [firmaIdInput, setFirmaIdInput] = useState(String(firmaId));
  const [fuarIdInput, setFuarIdInput] = useState(String(fuarId));

  // Gömülüyken (Firma Detay › Profil & Belgeler) `?tab=` Firma Detay'ın KENDİ sekmesidir ("profil"): iç sekmeyi
  // de oradan okumak her açılışta "Firma Bilgileri"ne düşürüyordu (#273). Gömülü sayfa iç sekmeyi `?profilTab=`
  // ile alır; bağımsız Profil rotası `?tab=` kullanmaya devam eder.
  const [activeTab, setActiveTab] = useState(() => {
    const requested = searchParams.get(embedded ? "profilTab" : "tab");
    return TABS.some((t) => t.key === requested) ? requested : "bilgiler";
  });
  // #595: iç sekme URL'ye de yazılır (yenilemede Diğer'de kalsın); Firma Detay'ın dış `?tab=`'ına dokunmaz.
  const selectTab = (key) => {
    setActiveTab(key);
    const next = new URLSearchParams(searchParams);
    next.set(embedded ? "profilTab" : "tab", key);
    setSearchParams(next, { replace: true });
  };

  const [profilePage, setProfilePage] = useState(null);
  // Backlog #60 — galeri profile-page cevabının ÜST seviyesinde (`fotograflar[]`) geliyor,
  // ayrı bir istek yok; her yazma tazelenmiş listeyi döndüğü için state doğrudan
  // onunla değiştiriliyor (sayfa yeniden yüklenmiyor).
  const [fotograflar, setFotograflar] = useState([]);
  // WAS (#212 öncesi): const [documents, setDocuments] = useState([]);  — GET /documents satırları
  // #212: GET /firma/{id}/evraklar — gruplar satırlarıyla (`dosya`) + digerBelgeler.
  const [evraklar, setEvraklar] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [infoMsg, setInfoMsg] = useState(null);
  const [reviewingId, setReviewingId] = useState(null);
  // #201 — şu an yüklenen grup belgesinin fileTypeId'si (aynı anda tek yükleme).
  const [uploadingFileTypeId, setUploadingFileTypeId] = useState(null);
  const [reloadToken, setReloadToken] = useState(0);
  const [rejectModal, setRejectModal] = useState({ isOpen: false, doc: null, reason: "" });
  // #736: the document in the delete confirmation ({ id, ad, approvalStatus }) or null.
  const [belgeSilModal, setBelgeSilModal] = useState(null);
  const [personnelModal, setPersonnelModal] = useState(EMPTY_YETKILI_MODAL);
  const [creatingPersonnel, setCreatingPersonnel] = useState(false);
  const [yetkiliDeleteModal, setYetkiliDeleteModal] = useState({ isOpen: false, kisi: null, deleting: false });
  // #106 — "Bağlı Kullanıcı Hesabı" seçeneği için firmanın portal hesapları. profile-page
  // bunları taşımıyor (yalnızca /detay → users[]), bu yüzden modal ilk açıldığında çekiliyor.
  const [kullanicilar, setKullanicilar] = useState(null);
  // Backlog #33 — Firma Bilgileri edit + hard-delete, replacing the dead FirmaListPage.jsx/
  // FirmaFormModal.jsx mock module (unrouted since the 2026-09-12 Kartlar/Detay rework).
  // #554: Düzenle artık ortak FirmaBilgileriDuzenleModal'ı (staff kipi) açar. Vergi no profile-page'de gelmiyor; modal açılmadan önce
  // GET /firma/{id}/tax-number'dan okunur (#197), okunamazsa alan modalda hiç gösterilmez ve PUT'a konmaz (yoksa kayıtlı değeri silerdi).
  // null = kapalı, { taxNumber, vergiNoGoster } = açık. WAS: editModal { isOpen, form, saving, taxNumberState } + EMPTY_EDIT_FORM.
  const [bilgiModal, setBilgiModal] = useState(null);
  const [bilgiAciliyor, setBilgiAciliyor] = useState(false);
  // WAS (until #550): deleteModal state + canHardDelete (GET /rbac/me) — the delete button asks the check endpoint, whose 403 is the same permission.

  useEffect(() => { document.title = i18n.t("moduller:firmaProfilInceleme.firmaProfiliInceleFds"); }, []);


  useEffect(() => {
    let ignore = false;

    async function run() {
      setLoading(true);
      setError(null);
      try {
        // WAS (#212 öncesi): ikinci çağrı firmaService.getFirmaDocumentsAdmin(firmaId, fuarId) → setDocuments
        const [profileData, evraklarData] = await Promise.all([
          firmaService.getFirmaProfilePage(firmaId, fuarId),
          firmaService.getFirmaEvraklari(firmaId, fuarId),
        ]);
        if (ignore) return;
        setProfilePage(profileData);
        setFotograflar(profileData?.fotograflar || []);
        setEvraklar(evraklarData);
      } catch (e) {
        if (!ignore) setError(e.response?.data?.message || e.message);
      } finally {
        if (!ignore) setLoading(false);
      }
    }

    run();
    return () => { ignore = true; };
  }, [firmaId, fuarId, reloadToken]);

  function showInfo(msg) {
    setInfoMsg(msg);
    setTimeout(() => setInfoMsg(null), 3500);
  }

  function goTo(e) {
    e.preventDefault();
    const id = firmaIdInput.trim();
    if (!id) return;
    navigate(`/Management/Firmalar/Profil/${id}?fuarId=${fuarIdInput.trim() || DEFAULT_FUAR_ID}`);
  }

  async function handleApprove(doc) {
    setReviewingId(doc.id);
    setError(null);
    try {
      await firmaService.reviewFirmaDocument(firmaId, doc.id, { status: 2, reviewedBy: REVIEWER_USER_ID });
      showInfo(tx("firmaProfilInceleme.onaylandi2", { docAdi: docAdi(doc) }));
      setReloadToken((t) => t + 1);
      // Atama belgesi onaylandıysa, belgede adı geçen kişiyi yetkili kaydına eklemeyi
      // teklif et. Hangi belgenin hangi rolü ürettiği artık katalogdan geliyor.
      const rol = belgeToRol[doc.fileTypeId];
      if (rol) openPersonnelModal(rol, tx("firmaProfilInceleme.onaylandiBelgedeAdiGecenKisiyi", { docAdi: docAdi(doc) }));
    } catch (e) {
      setError(e.response?.data?.message || e.message);
    } finally {
      setReviewingId(null);
    }
  }

  async function ensureKullanicilar() {
    if (kullanicilar !== null) return;
    try {
      setKullanicilar(await getFirmaKullanicilar(firmaId, { forceLive: true, fuarId }));
    } catch (e) {
      // Hesap listesi gelmezse alan boş seçenekle kalır; kayıt işlemi bundan etkilenmez.
      setKullanicilar([]);
      setError(e.response?.data?.message || e.message);
    }
  }

  function openPersonnelModal(rol, contextLabel = "") {
    setPersonnelModal({ ...EMPTY_YETKILI_MODAL, isOpen: true, rol, rolLocked: !!contextLabel, contextLabel });
    ensureKullanicilar();
  }

  function openYetkiliEditModal(kisi) {
    setPersonnelModal({
      isOpen: true, mode: "edit", id: kisi.id, rol: kisi.rol || "", rolLocked: false, contextLabel: "",
      form: yetkiliFormundan(kisi),
      foto: { ...EMPTY_YETKILI_FOTO, mevcutUrl: kisi.fotografUrl || null },
    });
    ensureKullanicilar();
  }

  function closePersonnelModal() {
    setPersonnelModal(EMPTY_YETKILI_MODAL);
  }

  /**
   * Üç yazma da firmanın GÜNCEL listesini `data`da döndürüyor, bu yüzden sayfanın
   * tamamını (belgeler dahil) yeniden çekmek yerine sadece yetkili listesi tazeleniyor.
   */
  function applyYetkiliListesi(response) {
    const liste = response?.data;
    if (Array.isArray(liste)) {
      setProfilePage((p) => (p ? { ...p, saglikGuvenlikYetkilileri: liste } : p));
    } else {
      setReloadToken((t) => t + 1);
    }
  }

  async function handleCreatePersonnel() {
    const { mode, id, rol, form, foto } = personnelModal;
    if (!form.adSoyad.trim() || !rol) return;
    setCreatingPersonnel(true);
    setError(null);
    setPersonnelModal((m) => ({ ...m, hata: null }));
    try {
      // PUT gerçek kısmi güncelleme; tüm alanları göndermek güvenli çünkü form mevcut
      // değerlerle dolduruldu — boşaltılan bir alan bilinçli olarak temizlenir. Profil
      // alanları (#106) yalnızca profil grubunun rolünde gidiyor.
      const payload = yetkiliPayload(rol, form, profilGrubuMu(seciliRol));
      const rolAd = rolAdiniBul(rol);
      // Servis `{ message, result, data: liste }` döndürüyor; yetkiliKaydet düz liste bekler.
      const { liste, fotoHatasi } = await yetkiliKaydet({
        mode, id, payload, foto, oncekiListe: saglikGuvenlikYetkilileri,
        api: {
          create: async (p) => (await firmaService.createFirmaYetkilisi(firmaId, p)).data,
          update: async (rid, p) => (await firmaService.updateFirmaYetkilisi(firmaId, rid, p)).data,
          uploadFoto: async (rid, f) => (await firmaService.uploadYetkiliFotograf(firmaId, rid, f)).data,
          deleteFoto: async (rid) => (await firmaService.deleteYetkiliFotograf(firmaId, rid)).data,
        },
      });
      applyYetkiliListesi({ data: liste });
      if (fotoHatasi) {
        setError(fotoHatasi);
      } else if (mode === "edit") {
        showInfo(tx("firmaProfilInceleme.guncellendi", { adSoyad: payload.adSoyad, rolAd }));
      } else {
        showInfo(tx("firmaProfilInceleme.firmaKaydinaEklendiFirmaTarafi", { adSoyad: payload.adSoyad, rolAd }));
      }
      closePersonnelModal();
    } catch (e) {
      // WAS: setError(e.response?.data?.message || e.message) - the page alert, behind the window that stays open until a save succeeds.
      setPersonnelModal((m) => ({ ...m, hata: e.response?.data?.message || e.message }));
    } finally {
      setCreatingPersonnel(false);
    }
  }

  async function handleDeleteYetkili() {
    const { kisi } = yetkiliDeleteModal;
    if (!kisi) return;
    setYetkiliDeleteModal((m) => ({ ...m, deleting: true }));
    setError(null);
    try {
      applyYetkiliListesi(await firmaService.deleteFirmaYetkilisi(firmaId, kisi.id));
      showInfo(tx("firmaProfilInceleme.kaydiSilindi", { adSoyad: kisi.adSoyad }));
      setYetkiliDeleteModal({ isOpen: false, kisi: null, deleting: false });
    } catch (e) {
      setError(e.response?.data?.message || e.message);
      setYetkiliDeleteModal((m) => ({ ...m, deleting: false }));
    }
  }

  function openRejectModal(doc) {
    setRejectModal({ isOpen: true, doc, reason: "" });
  }

  async function handleRejectConfirm() {
    const { doc, reason } = rejectModal;
    if (!reason.trim()) return;
    setReviewingId(doc.id);
    setError(null);
    try {
      await firmaService.reviewFirmaDocument(firmaId, doc.id, {
        status: 3, reviewedBy: REVIEWER_USER_ID, rejectReason: reason.trim(),
      });
      showInfo(tx("firmaProfilInceleme.reddedildi2", { docAdi: docAdi(doc) }));
      setRejectModal({ isOpen: false, doc: null, reason: "" });
      setReloadToken((t) => t + 1);
    } catch (e) {
      setError(e.response?.data?.message || e.message);
    } finally {
      setReviewingId(null);
    }
  }

  // #201 — personel firma adına bir grup belgesi yükler. Belge Beklemede'ye düşer; aynı satırdaki
  // Onayla ile onaylanır. Yüklemeden sonra satırı yeniden okumak için sayfa tazelenir, çünkü
  // yükleme yeni belgenin id'sini döndürmüyor.
  async function handleUpload(belge, file) {
    setUploadingFileTypeId(belge.fileTypeId);
    setError(null);
    try {
      await uploadFirmaGrupBelgesi(firmaId, belge, file, { forceLive: true, fuarId });
      showInfo(tx("firmaProfilInceleme.yuklendiOnayBekliyor", { belgeGorunenAd: belgeGorunenAd(belge.fileTypeId, belge.ad) }));
      setReloadToken((t) => t + 1);
    } catch (e) {
      setError(e.response?.data?.message || e.message);
    } finally {
      setUploadingFileTypeId(null);
    }
  }

  async function openEditModal() {
    setBilgiAciliyor(true);
    try {
      setBilgiModal({ taxNumber: (await getTaxNumber(firmaId)) || "", vergiNoGoster: true });
    } catch {
      setBilgiModal({ taxNumber: "", vergiNoGoster: false });
    } finally {
      setBilgiAciliyor(false);
    }
  }

  // WAS (until #550): openDeleteModal / closeDeleteModal / handleDeleteConfirm — KontrolluSilDugmesi owns the window and the delete now.

  const profile = profilePage?.profile;
  // Silme onayı için yazılması gereken metin — kısa ad yoksa tam ada düş; ikisi de yoksa
  // (olmamalı, firmaName backend'de zorunlu) buton hiç aktif olmaz.
  const deleteConfirmTarget = (profile?.firmaShortName || profile?.firmaName || "").trim();
  // #62: rol kataloğu profile-page'in kendisiyle birlikte geliyor, ayrı bir çağrı yok.
  const yetkiliRolleri = profilePage?.yetkiliRolleri || [];
  const saglikGuvenlikYetkilileri = profilePage?.saglikGuvenlikYetkilileri || [];
  const yetkiliGruplari = buildYetkiliGruplari(saglikGuvenlikYetkilileri, yetkiliRolleri);
  const belgeToRol = belgeTipiRolHaritasi(yetkiliRolleri);
  // Ekleme/düzenleme formunun rol seçenekleri: `tekil` bir rol doluysa listeden düşer
  // (backend zaten 400 ile reddediyor, kullanıcıyı oraya hiç sokmuyoruz). Düzenlemede
  // satırın KENDİ rolü elenmemeli, bu yüzden haricId = açık modalın satırı.
  const secilebilirRoller = eklenebilirRoller(yetkiliRolleri, saglikGuvenlikYetkilileri, personnelModal.id);
  // Grup başlığındaki "Ekle" butonu ise haricId ALMAZ: aksi halde tek kayıtlı bir `tekil`
  // rolü düzenlerken buton modalın arkasında yeniden belirir, modal kapanınca kaybolurdu.
  const eklenebilirGrupRolleri = eklenebilirRoller(yetkiliRolleri, saglikGuvenlikYetkilileri);
  const seciliRol = yetkiliRolleri.find((r) => r.kod === personnelModal.rol) || null;
  const rolAdiniBul = (kod) => yetkiliRolleri.find((r) => r.kod === kod)?.ad || kod;

  // #156 — Belgeler tablosu iki firma belge grubuna bölünüyor. Grubun her belgesi yüklenmemiş olsa da
  // bir satır alır; hiçbir grup satırına eşlenmeyen belge (taşeron formları, fuar kuralı belgeleri,
  // eski kopyalar…) "Diğer Belgeler"e düşer. Gruplar gelmezse tablo eskisi gibi tek düz liste.
  // #212: eşlemeyi backend yapıyor (evraklar: belgeGruplari[].belgeler[].dosya + digerBelgeler).
  // WAS: gruplar profile-page'in belgeGruplari[]'ından, satır grupBelgesininSatiri(documents, belge, fuarId)
  //      ile, digerBelgeler = documents.filter(eşlenmeyen).
  const grupBolumleri = siraliBelgeGruplari(evraklar?.belgeGruplari || []).map((grup) => ({
    grup,
    satirlar: (grup.belgeler || []).map((belge) => ({ belge, doc: belge.dosya ?? null })),
  }));
  const digerBelgeler = evraklar?.digerBelgeler || [];
  // #503: kurumun bu firmaya verdiği şablonlar (boş form / örnek), evraklar.sablonlar'dan — denetmen firmanın indirdiği dosyayı görür.
  const sablonlar = sablonHaritasi(evraklar?.sablonlar);
  // Gruplara bağlı satırlar + diğerleri = GET /documents'ın tümü.
  const documents = [...grupBolumleri.flatMap(({ satirlar }) => satirlar.map((s) => s.doc).filter(Boolean)), ...digerBelgeler];
  // 2026-08-10 mock fixture'ının 5 belgesi hatalı seedlendi (filePath "firma-documents/…"
  // gibi bir "/" içeriyor) — PublicFileController "/" içeren dosya adını 400 ile reddeder
  // (bkz. rehber). Gerçek POST /documents/upload üzerinden yüklenen dosyalar (ör. bu
  // sayfadan onaylanan/reddedilen Fuar Sözleşmesi) düz bir dosya adı üretir ve sorunsuz açılır.
  const hasUnservableFixtureDoc = documents.some((d) => d.filePath && d.filePath.includes("/"));

  // #251 — not (gruba sayılmaz / yerine geçer / yerine İşveren görevlendirmesi geçerli)
  // `zorunlu`dan değil belgeNotu'dan: 99 `zorunlu: false` ama gruba sayılan ikinci yol.
  function belgeAdi(fileTypeId, ad, belge, grup) {
    const not = belge ? belgeNotu(belge, grup) : null;
    return (
      <>
        <FileText size={14} className="me-1 text-muted" />
        {belgeGorunenAd(fileTypeId, ad)}
        {not && <span className="text-muted ms-1">({not})</span>}
        {/* #541: the İSG Taahhütnamesi form is generated for this company and fair; WAS the uploaded blank form like every other document. */}
        {fileTypeId === ISG_TAAHHUTNAMESI_FILE_TYPE_ID && <IsgTaahhutnameIndir firmaId={firmaId} firmaAdi={profile?.firmaName || ""} fuarId={fuarId} hizalama="start" className="small mt-1" />}
        <BelgeSablonuBaglantilari sablon={fileTypeId === ISG_TAAHHUTNAMESI_FILE_TYPE_ID ? { ornek: sablonlar[fileTypeId]?.ornek } : sablonlar[fileTypeId]} className="small mt-1" />
      </>
    );
  }

  // #201 — grup belgesi için firma adına yükleme düğmesi (satırın İşlemler hücresine).
  function yukleButonu(belge) {
    const inputId = `firma-belge-yukle-${belge.fileTypeId}`;
    const yukleniyor = uploadingFileTypeId === belge.fileTypeId;
    return (
      <>
        <input
          id={inputId}
          type="file"
          className="d-none"
          onChange={(e) => {
            const file = e.target.files?.[0];
            if (file) handleUpload(belge, file);
            e.target.value = "";
          }}
        />
        <Button
          color="primary" outline size="sm" disabled={uploadingFileTypeId != null}
          onClick={() => document.getElementById(inputId)?.click()} title={tx("firmaProfilInceleme.firmaAdinaBelgeYukle")}
        >
          {yukleniyor ? <Spinner size="sm" /> : <Upload size={14} />}
        </Button>
      </>
    );
  }

  function bolumBasligi(key, baslik, durum, kartNotu) {
    return (
      <tr key={key} className="table-light">
        <td colSpan={6} className="small fw-semibold">
          {baslik}
          {durum && <Badge color={durum.color} className="ms-2">{durum.label}</Badge>}
          {kartNotu && <Badge color="info" className="ms-1 fw-normal">{kartNotu}</Badge>}
        </td>
      </tr>
    );
  }

  function yuklenmemisSatir(belge, grup) {
    return (
      <tr key={`yok-${belge.fileTypeId}`}>
        <td className="small">{belgeAdi(belge.fileTypeId, belge.ad, belge, grup)}</td>
        <td className="small">
          {belge.fuaraOzel ? <Badge color="info">{tx("firmaProfilInceleme.fuar")}{" "}{fuarId}</Badge> : <Badge color="light" className="text-dark">{tx("firmaProfilInceleme.firmaGeneli")}</Badge>}
        </td>
        {/* #442: UYGULANAMAZ belge "Yüklenmedi" değil nötr "Uygulanamaz" okunur ve firma adına yükleme düğmesi yoktur. */}
        <td>
          {belgeUygulanamazMi(belge)
            ? <Badge color={uygulanamazDurumu().color}>{uygulanamazDurumu().label}</Badge>
            : <Badge color={RAW_STATUS[0].color}>{RAW_STATUS[0].label}</Badge>}
        </td>
        <td className="small text-muted">—</td>
        <td className="small">—</td>
        <td>
          <div className="d-flex gap-1">{belgeUygulanamazMi(belge) ? null : yukleButonu(belge)}</div>
        </td>
      </tr>
    );
  }

  function belgeSatiri(doc, belge, grup) {
    const status = RAW_STATUS[doc.approvalStatus] ?? RAW_STATUS[0];
    const fileUrl = getFirmaDocumentFileUrl(doc.filePath);
    const isReviewing = reviewingId === doc.id;
    const saglikRol = belgeToRol[doc.fileTypeId];
    return (
      <tr key={doc.id}>
        <td className="small">{belgeAdi(doc.fileTypeId, doc.fileTypeName, belge, grup)}</td>
        <td className="small">
          {doc.fuarId ? <Badge color="info">{tx("firmaProfilInceleme.fuar")}{" "}{doc.fuarId}</Badge> : <Badge color="light" className="text-dark">{tx("firmaProfilInceleme.firmaGeneli")}</Badge>}
        </td>
        <td>
          <Badge color={status.color}>{status.label}</Badge>
          {/* #442: bu belgenin kaydı var ama firmaya uygulanamaz (yabancı firma, onaylı İşveren görevlendirmesi): sayıma girmez. */}
          {belgeUygulanamazMi(belge) && <Badge color={uygulanamazDurumu().color} className="ms-1">{uygulanamazDurumu().label}</Badge>}
          {doc.approvalStatus === 3 && doc.rejectReason && (
            <div className="text-danger small mt-1">{doc.rejectReason}</div>
          )}
        </td>
        {/* WAS: <td className="small text-muted">{formatDate(doc.updateDate)}</td> */}
        <td className="small text-muted">
          {formatDate(doc.updateDate)}
          {/* #257 — yükleyen (personel mi firma mı) ve, incelenmiş satırda, inceleyen. */}
          {(doc.uploadedByName || doc.uploadedByStaff != null) && (
            <div>
              {tx("firmaProfilInceleme.yukleyen")}{" "}{doc.uploadedByName || "—"}
              {doc.uploadedByStaff != null && ` (${doc.uploadedByStaff ? tx("firmaProfilInceleme.personel") : tx("firmaProfilInceleme.firma")})`}
            </div>
          )}
          {doc.reviewedByName && <div>{tx("firmaProfilInceleme.inceleyen")}{" "}{doc.reviewedByName}</div>}
        </td>
        <td className="small">
          {fileUrl ? (
            <a href={fileUrl} target="_blank" rel="noreferrer">
              {tx("common:goruntule")}{" "}<ExternalLink size={12} />
            </a>
          ) : "—"}
        </td>
        <td>
          <div className="d-flex gap-1">
            <Button
              color="success" outline size="sm" disabled={isReviewing || doc.approvalStatus === 2}
              onClick={() => handleApprove(doc)}
              /* #483: the document that stands in for others (`yerineGecer`, today 99) is approved on the inspector's word that the
                 company is small enough (the retired toggle used to record that); no fileTypeId here, the backend flags it.
                 WAS: title={tx("firmaProfilInceleme.onayla")}. Dropping the reminder later: #509. */
              title={belge?.yerineGecer?.length ? tx("firmaProfilInceleme.onaylaYerineGecer") : tx("firmaProfilInceleme.onayla")}
            >
              {isReviewing ? <Spinner size="sm" /> : <CheckCircle2 size={14} />}
            </Button>
            <Button
              color="danger" outline size="sm" disabled={isReviewing || doc.approvalStatus === 3}
              onClick={() => openRejectModal(doc)} title={tx("firmaProfilInceleme.reddet")}
            >
              <XCircle size={14} />
            </Button>
            {saglikRol && (
              <Button
                color="primary" outline size="sm"
                onClick={() => openPersonnelModal(saglikRol, tx("firmaProfilInceleme.belgesindeAdiGecenKisiyiKaydedin", { docAdi: docAdi(doc) }))}
                title={tx("firmaProfilInceleme.buBelgedenKaydiOlustur", { rolAdiniBul: rolAdiniBul(saglikRol) })}
              >
                <UserPlus size={14} />
              </Button>
            )}
            {/* #201 — yalnızca grup belgesinin reddedilmiş satırında; Diğer Belgeler'e (taşeron
                formları, fuar kuralı belgeleri) firma adına yükleme yok. */}
            {belge && doc.approvalStatus === 3 && yukleButonu(belge)}
            {/* #736 — staff delete any uploaded document; an approved one asks for a second confirmation naming the effect on the cards. */}
            <Button
              color="danger" outline size="sm" disabled={isReviewing}
              onClick={() => setBelgeSilModal({ id: doc.id, ad: docAdi(doc), approvalStatus: doc.approvalStatus })}
              title={tx("belgeSil:belgeSil.sil")} data-testid={`belge-sil-${doc.id}`}
            >
              <Trash2 size={14} />
            </Button>
          </div>
        </td>
      </tr>
    );
  }

  return (
    <PageFrame embedded={embedded}>
      <PageBody embedded={embedded} title={tx("firmaProfilInceleme.firmaProfiliIncele")} pageTitle={tx("firmaProfilInceleme.firmalar")}>

        {!embedded && (
        <Card className="mb-3">
          <CardBody>
            <form className="row g-2 align-items-end" onSubmit={goTo}>
              <Col xs="auto">
                <Label className="small text-muted mb-1">{tx("firmaProfilInceleme.firmaId")}</Label>
                <Input bsSize="sm" style={{ width: 140 }} value={firmaIdInput} onChange={(e) => setFirmaIdInput(e.target.value)} />
              </Col>
              <Col xs="auto">
                <Label className="small text-muted mb-1">{tx("firmaProfilInceleme.fuarId")}</Label>
                <Input bsSize="sm" style={{ width: 120 }} value={fuarIdInput} onChange={(e) => setFuarIdInput(e.target.value)} />
              </Col>
              <Col xs="auto">
                <Button color="primary" size="sm" type="submit">{tx("common:goruntule")}</Button>
              </Col>
            </form>
          </CardBody>
        </Card>
        )}

        {error && <Alert color="danger">{error}</Alert>}
        {infoMsg && <Alert color="success">{infoMsg}</Alert>}

        {loading && (
          <div className="text-center py-5">
            <Spinner color="primary" />
            <p className="mt-2">{tx("common:yukleniyor")}</p>
          </div>
        )}

        {!loading && profile && (
          <>
            {/* Gömülü modda kimlik başlığını FirmaDetayPage basıyor — burada tekrarlama.
                Sekme çubuğu (backlog #11) gömülü modda da kalıyor: FirmaDetayPage'in "Profil &
                Belgeler" sekmesi bu bileşeni TEK bir dış sekme olarak gömüyor, ve bu üç iç bölüm
                (bilgiler/yetkililer/belgeler) arasında gezinecek başka bir kontrol yok — sekmeleri
                de kaldırırsak activeTab state'i hiçbir zaman değişemeyen ölü bir kontrole dönüşür. */}
            {!embedded && (
            <Card className="mb-3">
              <CardBody className="d-flex align-items-center gap-3 flex-wrap">
                <div
                  className="bg-light rounded-3 d-flex align-items-center justify-content-center flex-shrink-0"
                  style={{ width: 56, height: 56 }}
                >
                  <Building2 size={28} className="text-danger" />
                </div>
                <div>
                  <h4 className="mb-0">{profile.firmaName}</h4>
                  <div className="text-muted small">
                    {tx("firmaProfilInceleme.firmaIdFuar", { firmaShortName: profile.firmaShortName, firmaId, fuarId })}
                  </div>
                </div>
              </CardBody>
            </Card>
            )}

            <Card className="mb-3 overflow-hidden">
              <Nav pills className="px-3 pt-3 gap-2 border-0">
                {TABS.map((t) => (
                  <NavItem key={t.key}>
                    <NavLink
                      active={activeTab === t.key}
                      className={activeTab === t.key ? "bg-danger text-white" : "bg-white text-dark"}
                      style={{ cursor: "pointer", borderRadius: "6px 6px 0 0" }}
                      onClick={() => selectTab(t.key)}
                    >
                      {t.label}
                    </NavLink>
                  </NavItem>
                ))}
              </Nav>
            </Card>

            {/* #313: uyruk + vergi kimliği, Firma Bilgileri'nin altında değil ÜSTÜNDE: firmanın hangi kurallara
                tabi olduğunu değiştiriyor. Belge grupları uyrukla değiştiği için kayıttan sonra yeniden okunur.
                WAS (#595 öncesi): OrganizatorYetkileriKarti (ve içindeki ödeme bağlantısı) da burada, bu kartın
                hemen altındaydı; artık "Diğer" sekmesinde. */}
            {activeTab === "bilgiler" && (
              <YabanciFirmaKarti
                firmaId={firmaId}
                onChanged={(mesaj) => { showInfo(mesaj); setReloadToken((t) => t + 1); }}
              />
            )}

            {/* #595: organizatör yetkileri + ödeme bağlantısı (ücretsiz kW aşımı) — OdemeBaglantisiKarti kartın içinde çizilir. */}
            {activeTab === "diger" && (
              <OrganizatorYetkileriKarti firmaId={firmaId} onChanged={(mesaj) => showInfo(mesaj)} />
            )}

            {activeTab === "bilgiler" && (
            <>
            <Card className="mb-3">
              <CardHeader className="bg-transparent d-flex align-items-center justify-content-between">
                <strong>{tx("firmaProfilInceleme.firmaBilgileri")}</strong>
                {/* WAS: yalnızca Düzenle butonu vardı. #195: Firmayı Sil, FIRMA_HARD_DELETE yetkisiyle. */}
                <div className="d-flex gap-2">
                  <Button color="warning" outline size="sm" onClick={openEditModal} disabled={bilgiAciliyor}>
                    <Pencil size={14} className="me-1" />{" "}{tx("common:duzenle")}
                  </Button>
                  {/* #550: asks GET /firma/{id}/kalici-silme-kontrolu first; 403 (no FIRMA_HARD_DELETE) hides it, a company with history is greyed with the reason.
                      WAS (#195): {canHardDelete && (<Button …onClick={openDeleteModal}>) — the permission came from a separate GET /rbac/me read. */}
                  <KontrolluSilDugmesi
                    key={firmaId} tur="firma" ad={profile.firmaName} onayMetni={deleteConfirmTarget}
                    kontrol={() => firmaService.getKaliciSilmeKontrolu(firmaId)}
                    sil={() => firmaService.hardDeleteFirma(firmaId)}
                    // Firma artık yok — bu sayfada (embedded dahil) kalınamaz, listeye dön.
                    onSilindi={() => navigate("/Management/Firmalar/Kartlar")}
                  />
                </div>
              </CardHeader>
              <CardBody>
                <Row>
                  <Col xs={12}>
                    {/* #60: logo firmaLogoUrl + firmaLogoSource'tan (#61); ham firmaLogo
                        sütunu dosyanın nerede durduğunu söylemediği için eskiden DTO'da
                        gelip hiç basılmıyordu. */}
                    <div className="d-flex align-items-center gap-3 mb-3">
                      <FirmaLogo profile={profile} size={56} />
                      <div>
                        <div className="fw-semibold">{profile.firmaName}</div>
                        <div className="text-muted small">{profile.firmaShortName}</div>
                      </div>
                    </div>
                  </Col>
                  <Col md={6}>
                    <div className="mb-2 small"><span className="text-muted">{tx("firmaProfilInceleme.adres")}</span> {profile.adres ?? "—"}</div>
                    <div className="mb-2 small"><span className="text-muted">{tx("firmaProfilInceleme.telefon")}</span> {profile.telefon ?? "—"}</div>
                  </Col>
                  <Col md={6}>
                    <div className="mb-2 small"><span className="text-muted">{tx("firmaProfilInceleme.ePosta")}</span> {profile.eposta ?? "—"}</div>
                    <div className="mb-2 small"><span className="text-muted">{tx("firmaProfilInceleme.webSitesi")}</span> {profile.webSitesi ?? "—"}</div>
                  </Col>
                </Row>
              </CardBody>
            </Card>

            {/*
              Backlog #60: katalog (kategoriler + açıklama), fotoğraf galerisi ve harita
              konumu — firma-tarafı Firma Kartı sayfasıyla ORTAK bloklar
              (Components/Firma/FirmaBilgiKartlari.jsx). Eskiden burada yalnızca tek satırlık
              "Katalog: ..." vardı; kategoriler, fotoğraf ve konum hiç görünmüyordu.
              Denetmen her firmanın bu alanlarını YAZABİLİR (yetki kontrolü firma kullanıcısını
              kendi firmasıyla sınırlar, personeli sınırlamaz — bkz. knowledgebase).
            */}
            <KatalogBilgileriCard
              firmaId={firmaId}
              profile={profile}
              canEdit
              onSaved={() => setReloadToken((t) => t + 1)}
            />

            <FirmaFotograflarCard
              firmaId={firmaId}
              photos={fotograflar}
              canEdit
              onChanged={setFotograflar}
            />

            <FirmaKonumCard
              firmaId={firmaId}
              profile={profile}
              canEdit
              onSaved={() => setReloadToken((t) => t + 1)}
            />

            {/*
              WAS (backlog #195 öncesi): sayfayı açabilen her role (1-8, 10-12, 14-18) görünen kırmızı
              "Tehlikeli Bölge" kartı. Firmayı Sil artık Firma Bilgileri başlığında, FIRMA_HARD_DELETE
              yetkisi olana görünen bir eylem; açıklama metni silme onay modalında zaten var.
            <Card className="mb-3 border-danger">
              <CardHeader className="bg-transparent text-danger"><strong>Tehlikeli Bölge</strong></CardHeader>
              <CardBody className="d-flex align-items-center justify-content-between flex-wrap gap-2">
                <div className="small text-muted" style={{ maxWidth: 520 }}>
                  Firmayı ve firma_to_fuar / kullanıcı / iletişim / not bağlantılarını kalıcı olarak
                  siler. Yüklenmiş belgeler, saha formları ve proje kayıtları silinmez, sahipsiz
                  kalır (PHP tarafındaki davranışla aynı). <strong>Geri alınamaz.</strong>
                </div>
                <Button color="danger" outline size="sm" onClick={openDeleteModal}>
                  <Trash2 size={14} className="me-1" /> Firmayı Sil
                </Button>
              </CardBody>
            </Card>
            */}
            </>
            )}

            {activeTab === "yetkililer" && (
            <>
            {yetkiliGruplari.length === 0 ? (
              <Card className="mb-3"><CardBody>
                <div className="text-muted small">{tx("firmaProfilInceleme.rolTanimiOkunamadiYetkililerListelenemiyor")}</div>
              </CardBody></Card>
            ) : yetkiliGruplari.map((grup) => {
              // Gruba eklenebilecek roller — hepsi `tekil` ve doluysa "Ekle" hiç basılmaz.
              const grupRolleri = eklenebilirGrupRolleri.filter((r) => r.grupKod === grup.grupKod);
              return (
                <Card className="mb-3" key={grup.grupKod || "diger"}>
                  <CardHeader className="bg-transparent d-flex align-items-center justify-content-between">
                    <strong>{grup.grupAd}</strong>
                    {grupRolleri.length > 0 && (
                      <Button color="primary" outline size="sm" onClick={() => openPersonnelModal(grupRolleri[0].kod)}>
                        <UserPlus size={14} className="me-1" />{" "}{tx("common:ekle")}
                      </Button>
                    )}
                  </CardHeader>
                  <CardBody>
                    {grup.kisiler.length === 0 ? (
                      <div className="text-muted small">{tx("firmaProfilInceleme.buGrubaKayitliYetkiliBulunamadi")}</div>
                    ) : profilGrubuMu(grup) ? (
                      grup.kisiler.map((k, i) => (
                        <div key={k.id} className={i > 0 ? "border-top mt-3 pt-3" : ""}>
                          <YetkiliProfilKarti
                            kisi={k}
                            actions={(
                              <>
                                <Button color="secondary" outline size="sm" title={tx("common:duzenle")} onClick={() => openYetkiliEditModal(k)}>
                                  <Pencil size={14} />
                                </Button>
                                <Button
                                  color="danger" outline size="sm" title={tx("common:sil")}
                                  onClick={() => setYetkiliDeleteModal({ isOpen: true, kisi: k, deleting: false })}
                                >
                                  <Trash2 size={14} />
                                </Button>
                              </>
                            )}
                          />
                        </div>
                      ))
                    ) : (
                      <Row>
                        {grup.kisiler.map((k) => {
                          const RolIcon = yetkiliIkonu(k);
                          return (
                            // lg (md değil): 768-992 arasında iki dar sütun, uzun e-postaları
                            // taşırıp işlem butonlarını komşu sütunun üstüne itiyordu.
                            // minWidth:0 olmadan flex çocuğu içeriğinin altına küçülmez.
                            <Col lg={6} key={k.id} className="d-flex align-items-start gap-2 mb-3">
                              <RolIcon size={20} className="text-muted mt-1 flex-shrink-0" />
                              <div className="small flex-grow-1 text-break" style={{ minWidth: 0 }}>
                                <Badge color="light" className="text-body border mb-1">{k.rolAd || k.rol || tx("firmaProfilInceleme.bilinmeyenRol")}</Badge>
                                <div className="fw-semibold">{k.adSoyad}{k.unvan ? ` — ${k.unvan}` : ""}</div>
                                <div className="text-muted">{k.telefon || "—"} · {k.email || "—"}</div>
                              </div>
                              <div className="d-flex gap-1 flex-shrink-0">
                                <Button color="secondary" outline size="sm" title={tx("common:duzenle")} onClick={() => openYetkiliEditModal(k)}>
                                  <Pencil size={14} />
                                </Button>
                                <Button
                                  color="danger" outline size="sm" title={tx("common:sil")}
                                  onClick={() => setYetkiliDeleteModal({ isOpen: true, kisi: k, deleting: false })}
                                >
                                  <Trash2 size={14} />
                                </Button>
                              </div>
                            </Col>
                          );
                        })}
                      </Row>
                    )}
                  </CardBody>
                </Card>
              );
            })}
            </>
            )}

            {activeTab === "kullanicilar" && (
              <FirmaKullanicilarBolumu firmaId={firmaId} firmaAdi={profile.firmaName} />
            )}

            {/* #483 (backend #482): the "İşveren İSG görevlendirmesi kabul edilir" switch is retired. 99 is offered to every
                Yerli company and counts once an inspector approves it (Onayla below), whatever 88 / 89 say.
                WAS (#251): <IsgIsverenIzniKarti firmaId={firmaId} onChanged={(mesaj, izinDegisti) => { showInfo(mesaj); if (izinDegisti) setReloadToken((t) => t + 1); }} /> on this tab. */}

            {activeTab === "belgeler" && (
            <Card>
              <CardHeader className="bg-transparent d-flex align-items-center justify-content-between">
                <strong>{tx("firmaProfilInceleme.belgeler")}</strong>
                <span className="text-muted small">{tx("firmaProfilInceleme.firmaGeneliBelgelerFuarBelgeleri", { fuarId })}</span>
              </CardHeader>
              <CardBody>
                {documents.length === 0 && grupBolumleri.length === 0 ? (
                  <div className="text-muted small">{tx("firmaProfilInceleme.buFirmaIcinYuklenmisBelge")}</div>
                ) : (
                  <div className="table-responsive">
                    <Table className="align-middle" borderless>
                      <thead>
                        <tr className="text-muted small text-uppercase">
                          <th>{tx("firmaProfilInceleme.belgeTuru")}</th>
                          <th>{tx("firmaProfilInceleme.kapsam")}</th>
                          <th>{tx("firmaProfilInceleme.durum")}</th>
                          <th>{tx("firmaProfilInceleme.guncelleme")}</th>
                          <th>{tx("firmaProfilInceleme.dosya")}</th>
                          <th>{tx("firmaProfilInceleme.islemler")}</th>
                        </tr>
                      </thead>
                      <tbody>
                        {grupBolumleri.map(({ grup, satirlar }) => [
                          bolumBasligi(`grup-${grup.kod}`, grup.baslik, grupDurumInfo(grup), grupKartNotu(grup)),
                          ...satirlar.map(({ belge, doc }) => (doc ? belgeSatiri(doc, belge, grup) : yuklenmemisSatir(belge, grup))),
                        ])}
                        {digerBelgeler.length > 0 && grupBolumleri.length > 0 && bolumBasligi("diger", tx("firmaProfilInceleme.digerBelgeler"))}
                        {digerBelgeler.map((doc) => belgeSatiri(doc))}
                      </tbody>
                    </Table>
                  </div>
                )}
                {hasUnservableFixtureDoc && (
                  <div className="text-muted small mt-2">
                    {tx("firmaProfilInceleme.not20260810Mock")}
                  </div>
                )}
              </CardBody>
            </Card>
            )}

            {/* Backlog #142 — paylaşımlı personel belgeleri (SGK Hizmet Dökümü / İSG Eğitim Katılım
                Listesi): personel çalışan BAŞINA onaylar/reddeder, yükleyip çalışan ekleyip çıkarabilir. */}
            {activeTab === "belgeler" && (
              <div className="mt-3">
                <PaylasimliBelgelerPanel firmaId={firmaId} staff />
              </div>
            )}
          </>
        )}

        {!loading && !profile && !error && (
          <Card className="p-5 text-center">
            <p className="text-muted mb-0">{tx("firmaProfilInceleme.buFirmaIcinProfilKaydi")}</p>
          </Card>
        )}
      </PageBody>

      <Modal isOpen={rejectModal.isOpen} toggle={() => setRejectModal({ isOpen: false, doc: null, reason: "" })}>
        <ModalHeader toggle={() => setRejectModal({ isOpen: false, doc: null, reason: "" })}>
          {tx("firmaProfilInceleme.belgeyiReddet")}
        </ModalHeader>
        <ModalBody>
          <p className="small text-muted">
            <strong>{rejectModal.doc && docAdi(rejectModal.doc)}</strong>{" "}{tx("firmaProfilInceleme.belgesiniReddetmeGerekceniziGirin")}
          </p>
          <Input
            type="textarea" rows={3} value={rejectModal.reason}
            onChange={(e) => setRejectModal((m) => ({ ...m, reason: e.target.value }))}
            placeholder={tx("firmaProfilInceleme.ornBelgeSuresiDolmusGuncelini")}
          />
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={() => setRejectModal({ isOpen: false, doc: null, reason: "" })}>{tx("common:iptal")}</Button>
          <Button color="danger" disabled={!rejectModal.reason.trim() || reviewingId === rejectModal.doc?.id} onClick={handleRejectConfirm}>
            {tx("firmaProfilInceleme.reddet")}
          </Button>
        </ModalFooter>
      </Modal>

      {/* #736: the row goes away and the document is "not uploaded" again once the page is read again. */}
      {belgeSilModal && (
        <FirmaBelgeSilModal
          key={belgeSilModal.id} firmaId={firmaId} belge={belgeSilModal}
          onClose={() => setBelgeSilModal(null)}
          onDeleted={(mesaj) => {
            setBelgeSilModal(null);
            showInfo(mesaj);
            setReloadToken((n) => n + 1);
          }}
        />
      )}

      <Modal isOpen={personnelModal.isOpen} toggle={closePersonnelModal}>
        <ModalHeader toggle={closePersonnelModal}>
          {personnelModal.mode === "edit" ? tx("firmaProfilInceleme.yetkiliyiDuzenle") : tx("firmaProfilInceleme.yetkiliEkle")}
        </ModalHeader>
        <ModalBody>
          {personnelModal.hata && <Alert color="danger" className="small py-2">{personnelModal.hata}</Alert>}
          {personnelModal.contextLabel && (
            <p className="small text-muted">{personnelModal.contextLabel}</p>
          )}
          <div className="mb-2">
            <Label className="small">{tx("firmaProfilInceleme.rol")}</Label>
            {personnelModal.rolLocked ? (
              <Input bsSize="sm" value={rolAdiniBul(personnelModal.rol)} disabled />
            ) : (
              <Input
                type="select" bsSize="sm" value={personnelModal.rol}
                onChange={(e) => setPersonnelModal((m) => ({ ...m, rol: e.target.value }))}
              >
                <option value="">{tx("firmaProfilInceleme.seciniz")}</option>
                {secilebilirRoller.map((r) => (
                  <option key={r.id} value={r.kod}>{r.grupAd} — {r.ad}</option>
                ))}
              </Input>
            )}
          </div>
          <div className="mb-2">
            <Label className="small">{tx("firmaProfilInceleme.adSoyad")}</Label>
            <Input
              bsSize="sm" value={personnelModal.form.adSoyad}
              onChange={(e) => setPersonnelModal((m) => ({ ...m, form: { ...m.form, adSoyad: e.target.value } }))}
            />
          </div>
          <div className="mb-2">
            <Label className="small">{tx("firmaProfilInceleme.unvan")}</Label>
            <Input
              bsSize="sm" value={personnelModal.form.unvan} placeholder={seciliRol?.unvanIpucu || ""}
              onChange={(e) => setPersonnelModal((m) => ({ ...m, form: { ...m.form, unvan: e.target.value } }))}
            />
          </div>
          <Row>
            <Col md={6}>
              <Label className="small">{tx("firmaProfilInceleme.telefon2")}</Label>
              <TelefonGirdisi
                bsSize="sm" value={personnelModal.form.telefon}
                onChange={(v) => setPersonnelModal((m) => ({ ...m, form: { ...m.form, telefon: v } }))}
              />
            </Col>
            <Col md={6}>
              <Label className="small">{tx("firmaProfilInceleme.email")}</Label>
              <Input
                bsSize="sm" value={personnelModal.form.email}
                onChange={(e) => setPersonnelModal((m) => ({ ...m, form: { ...m.form, email: e.target.value } }))}
              />
            </Col>
          </Row>
          {profilGrubuMu(seciliRol) && (
            <YetkiliProfilAlanlari
              form={personnelModal.form}
              onFormChange={(form) => setPersonnelModal((m) => ({ ...m, form }))}
              foto={personnelModal.foto}
              onFotoChange={(foto) => setPersonnelModal((m) => ({ ...m, foto }))}
              kullanicilar={kullanicilar || []}
            />
          )}
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={closePersonnelModal}>{tx("common:iptal")}</Button>
          <Button
            color="primary"
            disabled={!personnelModal.form.adSoyad.trim() || !personnelModal.rol || creatingPersonnel}
            onClick={handleCreatePersonnel}
          >
            {creatingPersonnel ? <Spinner size="sm" /> : tx("common:kaydet")}
          </Button>
        </ModalFooter>
      </Modal>

      <Modal
        isOpen={yetkiliDeleteModal.isOpen}
        toggle={() => setYetkiliDeleteModal({ isOpen: false, kisi: null, deleting: false })}
      >
        <ModalHeader toggle={() => setYetkiliDeleteModal({ isOpen: false, kisi: null, deleting: false })}>
          {tx("firmaProfilInceleme.yetkiliyiSil")}
        </ModalHeader>
        <ModalBody>
          <p className="mb-2">
            <strong>{yetkiliDeleteModal.kisi?.adSoyad}</strong>
            {yetkiliDeleteModal.kisi?.rolAd ? ` (${yetkiliDeleteModal.kisi.rolAd})` : ""}{" "}{tx("firmaProfilInceleme.kaydiKaliciOlarakSilinecek")}
          </p>
          <div className="text-muted small">
            {tx("firmaProfilInceleme.yuklenmisAtamaBelgesiSilinmezFirma")}{" "}<strong>{tx("firmaProfilInceleme.geriAlinamaz")}</strong>
          </div>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={() => setYetkiliDeleteModal({ isOpen: false, kisi: null, deleting: false })}>
            {tx("common:iptal")}
          </Button>
          <Button color="danger" disabled={yetkiliDeleteModal.deleting} onClick={handleDeleteYetkili}>
            {yetkiliDeleteModal.deleting ? <Spinner size="sm" /> : tx("common:sil")}
          </Button>
        </ModalFooter>
      </Modal>

      {/* #554: ortak Firma Bilgilerini Düzenle modalı, personel kipinde — ad, kısa ad, uyruk + ülke (adıyla), iletişim, vergi no. */}
      {bilgiModal && (
        <FirmaBilgileriDuzenleModal
          staff
          toggle={() => setBilgiModal(null)}
          firmaId={firmaId}
          profile={profile}
          taxNumber={bilgiModal.taxNumber}
          vergiNoGoster={bilgiModal.vergiNoGoster}
          yabanci={profile?.firmaNation === 2}
          onSaved={({ tamam }) => {
            if (tamam) {
              setBilgiModal(null);
              showInfo(tx("firmaProfilInceleme.firmaBilgileriGuncellendi"));
            }
            setReloadToken((t) => t + 1);
          }}
        />
      )}

      {/* WAS (until #550): the permanent-delete window lived here (typed company name, its own deleteModal state); KontrolluSilDugmesi carries it now. */}
    </PageFrame>
  );
}
